import React from 'react';
import { makeStyles } from '@material-ui/core';
import { TransitionProps } from '@material-ui/core/transitions';

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Slide,
  units,
} from '@ha/dsl';

import { OverlayProps } from '../types';
import DatePickerDialogTitle from './Dialog/DialogTitle';

export const useStyles = makeStyles(theme => ({
  dialogRoot: {
    // Iphone 5/SE
    [theme.breakpoints.down(321)]: {
      borderRadius: 0,
      width: '100%',
      height: '100%',
      margin: 0,
      maxWidth: '100%',
      maxHeight: 'none',
    },
  },
  dialogContentRoot: {
    padding: units.yx(0, 0.5),
    [theme.breakpoints.up('sm')]: {
      padding: 0,
    },
  },
  dialogTitleRoot: {
    padding: units.yx(0.75, 1),
  },
}));

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children?: React.ReactElement },
  ref: React.RefObject<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const DatePickerDialog: React.FC<OverlayProps> = props => {
  const {
    children,
    focused,
    from,
    onFieldFocusChange,
    onOverlayClose,
    onOverlayExit,
    open,
    OverlayActions,
    OverlayInfo,
    to,
  } = props;
  const classes = useStyles();

  return (
    <Dialog
      data-test-locator="DatePicker / Overlay / Dialog"
      maxWidth="md"
      onClose={onOverlayClose}
      onExit={onOverlayExit}
      open={open}
      PaperProps={{
        classes: { root: classes.dialogRoot },
      }}
      TransitionComponent={Transition}
    >
      <DialogTitle
        disableTypography
        classes={{ root: classes.dialogTitleRoot }}
      >
        <DatePickerDialogTitle
          from={from}
          focused={focused}
          onFieldFocusChange={onFieldFocusChange}
          to={to}
        />
      </DialogTitle>
      <DialogContent classes={{ root: classes.dialogContentRoot }} dividers>
        {children}
        {OverlayInfo}
      </DialogContent>
      <DialogActions>{OverlayActions}</DialogActions>
    </Dialog>
  );
};

export default DatePickerDialog;
